/* DESIGN.md §6.3: the queue on the left (320px), the selected patient's work on the right.
   The queue stays in view while the triage form scrolls. Below 900px (a phone, or a small
   tablet) the two stack; with a patient selected their work comes first and the queue
   follows, so a nurse on a phone isn't scrolling past the list to reach the form. */
.split {
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  gap: var(--space-5) var(--space-6);
  align-items: start;
}

.queue {
  position: sticky;
  top: calc(var(--topbar-height) + var(--space-5));
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
  max-height: calc(100vh - var(--topbar-height) - var(--space-6));
  overflow-y: auto;
}

@media (width < 900px) {
  .split {
    grid-template-columns: minmax(0, 1fr);
  }

  .queue {
    position: static;
    max-height: none;
    overflow: visible;
  }

  .split[data-selected] .detail {
    order: -1;
  }
}

@media (height < 600px) {
  .queue {
    position: static;
    max-height: none;
    overflow: visible;
  }
}

.queueSummary {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
  font-variant-numeric: tabular-nums;
}

.callNext {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.detail {
  min-width: 0;
}

.work {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: center;
}

/* "Admit" beside the consultation button at a casualty point (casualty plan §5). */
.link {
  font: var(--t-body-strong);
}

/* Choosing a queue: one full-width row per queue, name first, the count beside it. */
.chooser {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

/* The card holds the rows; the last row needs no rule under it. */
.chooser > li:last-child .chooserRow {
  border-bottom: 0;
}

.chooserRow {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-1) var(--space-4);
  width: 100%;
  min-height: var(--row-height);
  padding: var(--space-3) var(--space-2);
  border: 0;
  border-bottom: 1px solid var(--rule);
  background: none;
  color: var(--ink);
  font: var(--t-body-strong);
  text-align: left;
  cursor: pointer;
}

.chooserRow:hover {
  background: var(--brand-tint);
}

/* The queue name reads as a link, like queue names on Home, so the row looks clickable. */
.chooserRow > :first-child {
  color: var(--brand);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.chooserRow:focus-visible {
  outline: var(--focus-ring);
  outline-offset: calc(-1 * var(--focus-offset));
}

.chooserCount {
  color: var(--graphite);
  font: var(--t-body);
  font-variant-numeric: tabular-nums;
}

.flags {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2) var(--space-5);
  margin: 0;
  padding: 0;
  border: 0;
}

.flagsLegend {
  float: left;
  margin-right: var(--space-3);
  padding: 0;
  font: var(--t-body-strong);
}
